import { useState } from "react"



export default function TextForm(props) {

    const [text, setText] = useState('');
    const handleUpClick = () => {
        let newtext = text.toUpperCase()
        setText(newtext)
        props.showAlert("Converted to Upper Case", "success")
    }

    const handlelowClick = () => {
        let newtext = text.toLowerCase();
        setText(newtext)
        props.showAlert("Converted to Lower Case", "success")

    }
    const handlelClear = () => {
        setText('')
        props.showAlert("Text Cleared!!!", "danger")

    }
    const handlelCopy = () => {
        let copyText = text;
        navigator.clipboard.writeText(copyText)
        props.showAlert("Copied to clipboard", "success")

    }
    const handleRemoveSpaces = () => {
        let newText = text.split(/[  ]+/);
        setText(newText.join(" "))
        props.showAlert("Extra-spaces have been romoved", "success")

    }

    const handleOnChange = (e) => {
        setText(e.target.value);
    }
    return (
        <>
            <div className="container" style={{ color: props.mode === 'dark' ? 'white' : 'black' }}>
                <h2 className="my-3">{props.heading}</h2>
                <div className="mb-3">
                    <textarea className="form-control" value={text} style={{
                        backgroundColor: props.mode === 'dark' ? '#212529' : 'white',
                        color: props.mode === 'dark' ? 'white' : 'black'
                    }} onChange={handleOnChange} id="myBox" rows="8"></textarea>
                </div>
                <button disabled={text.length === 0} className="btn btn-primary mx-1 my-2" onClick={handleUpClick}>Convert to  Uppercase</button>
                <button disabled={text.length === 0} className="btn btn-primary mx-1 my-2" onClick={handlelowClick}>Convert to  Lowercase</button>
                <button disabled={text.length === 0} className="btn btn-primary mx-1 my-2" onClick={handlelClear}>Clear Text</button>
                <button disabled={text.length === 0} className="btn btn-primary mx-1 my-2" onClick={handlelCopy}>Copy Text</button>
                <button disabled={text.length === 0} className="btn btn-primary mx-1 my-2" onClick={handleRemoveSpaces}>Remove Extra Spaces</button>

            </div>
            <div className="container my-3" style={{ color: props.mode === 'dark' ? 'white' : 'black' }} >
                <h2>Your text summary</h2>
                <p>{((text.trim().split(" ")).filter((element) => {
                    return element !== "";
                })).length} Words , {text.length} Characters </p>
                <p>{0.008 * text.trim(" ").length} Minutes read</p>
                <h2>Preview</h2>
                <p>{text.length > 0 ? text : "Nothing to preview !!!" }</p>
            </div>
        </>
    )
}
